import React from 'react';
import CommonDialog from './CommonDialog';


const ConfirmDialog = ({ showDialog, dialogId, title, body, onConfirm, onCancel }) => {
  return (
    <CommonDialog
      show={showDialog}
      dialogId={dialogId}
      title={title}
      noCloseBtn={true}
      body={body}
      onConfirm={onConfirm}
      onCancel={onCancel}
      bodyClass='modal-body-center'
    />
  );
};

export default ConfirmDialog; 